import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
// Third party packages
import { MatDialog, MatDialogRef, MatSlideToggleChange } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { finalize } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { PropertyTagNfcsService } from 'src/app/modules/properties/propertyTagNfcs.service';
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
/**
 * Script start
 */
var PropertyTagNfcEditDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertyTagNfcEditDialogComponent(dialogRef, data, configService, translateService, authService, cookieService, dialog, toastrService, helperService, propertyTagNfcsService, confirmDialog) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.configService = configService;
        this.translateService = translateService;
        this.authService = authService;
        this.cookieService = cookieService;
        this.dialog = dialog;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.propertyTagNfcsService = propertyTagNfcsService;
        this.confirmDialog = confirmDialog;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.dialogIsLoading = false; // Used to view/hide form loading spinner
        this.enableEdit = false;
        // BEGIN - Edit phonebook contact form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {
            formState: {
                disabled: true
            }
        };
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
        // END - Edit phonebook contact form
        this.loggedUserMaster = false;
        this.pageTitle = '';
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    PropertyTagNfcEditDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        var currentRole = this.loggedUser.userRoles.find(function (obj) {
            return (obj._id.toString() ===
                _this.authService.loggedUserRequestedRole$.getValue().toString());
        });
        if (currentRole.role.type === "master" ||
            currentRole.role.type === "collaborator") {
            this.loggedUserMaster = true;
            this.pageTitle = this.translateService.instant("propertyTagNfc.dialog.view.title");
        }
        else {
            this.pageTitle = this.translateService.instant("propertyTagNfc.dialog.edit.title");
        }
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        // Init add form
        if (this.loggedUserMaster) {
            this.initMasterForm();
        }
        else {
            this.initForm();
        }
        // Stop loading dialog
        this.dialogIsLoading = false;
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    PropertyTagNfcEditDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    PropertyTagNfcEditDialogComponent.prototype.initForm = function () {
        var _this = this;
        if (this.data) {
            var createdBy = '';
            if (this.data.createdBy &&
                this.data.createdBy.firstName) {
                createdBy = this.data.createdBy.firstName + " " + this.data.createdBy.lastName;
            }
            var updatedBy = '';
            if (this.data.updatedBy &&
                this.data.updatedBy.firstName) {
                updatedBy = this.data.updatedBy.firstName + " " + this.data.updatedBy.lastName;
            }
            if (this.enableEdit) {
                this.options.formState = {
                    disabled: false
                };
            }
            this.model["files"] = this.data.images;
            this.fields.push({
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        type: "file-uploader-structure",
                        key: "files",
                        defaultValue: this.data.images,
                        templateOptions: {
                            required: false,
                            allowedFilesNumber: 3,
                            allowedFilesExtensions: 'jpg,jpeg,png,gif',
                            customLabel: this.translateService.instant("propertyTagNfc.fields.images"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "input",
                        key: "uid",
                        defaultValue: this.data.uid,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.uid"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.uid"),
                            required: true,
                            minLength: 0,
                            maxLength: 1000,
                            rows: 4,
                            disabled: true,
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "input",
                        key: "name",
                        defaultValue: this.data.name,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.name"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.name"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "select",
                        key: "shortDescription",
                        defaultValue: this.data.shortDescription,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.shortDescription"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.shortDescription"),
                            required: false,
                            options: [
                                {
                                    value: "externalPushButtonPanel",
                                    label: this.translateService.instant("propertyTagNfc.shortDescription.externalPushButtonPanel"),
                                },
                                {
                                    value: "understairsPushButtonPanel",
                                    label: this.translateService.instant("propertyTagNfc.shortDescription.understairsPushButtonPanel"),
                                },
                                {
                                    value: "dedicatedLocalAccessDoor",
                                    label: this.translateService.instant("propertyTagNfc.shortDescription.dedicatedLocalAccessDoor"),
                                },
                                {
                                    value: "driveway",
                                    label: this.translateService.instant("propertyTagNfc.shortDescription.driveway"),
                                },
                                {
                                    value: "other",
                                    label: this.translateService.instant("propertyTagNfc.shortDescription.other"),
                                },
                            ],
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "textarea",
                        key: "description",
                        defaultValue: this.data.description,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.description"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.description"),
                            required: false,
                            minLength: 0,
                            maxLength: 1000,
                            rows: 4
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "input",
                        key: "latitude",
                        defaultValue: this.data.latitude,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.latitude"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.latitude"),
                            required: false,
                            disabled: true,
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "input",
                        key: "longitude",
                        defaultValue: this.data.longitude,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.longitude"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.longitude"),
                            required: false,
                            disabled: true,
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "datepicker",
                        key: "installationDate",
                        defaultValue: this.data.installationDate,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.installationDate"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.installationDate"),
                            required: true,
                            disabled: true,
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "input",
                        key: "createdBy",
                        defaultValue: createdBy,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.createdBy"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.createdBy"),
                            required: false,
                            disabled: true
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "datepicker",
                        key: "createdAt",
                        defaultValue: this.data.createdAt,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.createdAt"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.createdAt"),
                            required: false,
                            disabled: true
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "input",
                        key: "updatedBy",
                        defaultValue: updatedBy,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.updatedBy"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.updatedBy"),
                            required: false,
                            disabled: true
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "datepicker",
                        key: "updatedAt",
                        defaultValue: this.data.updatedAt,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.updatedAt"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.updatedAt"),
                            required: false,
                            disabled: true
                        },
                        wrappers: ['form-field-horizontal']
                    },
                ],
            });
        }
    };
    /**
     * Init master form
     *
     * @since 1.0.0
     */
    PropertyTagNfcEditDialogComponent.prototype.initMasterForm = function () {
        var e_1, _a;
        var _this = this;
        if (this.data) {
            var apiHost = this.configService.apiHost;
            var imagesContainer = '';
            if (this.data.images && Array.isArray(this.data.images)) {
                try {
                    for (var _b = tslib_1.__values(this.data.images), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var image = _c.value;
                        var path = image.path;
                        // if (path.startsWith("public")) {
                        if (path.substring(0, apiHost.length) !== apiHost) {
                            var newPath = apiHost + "\\" + path;
                            image.path = newPath;
                        }
                        imagesContainer = imagesContainer + "<img src=\"" + image.path + "\" alt=\"" + image.originalName + "\">";
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            this.fields.push({
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12 boxForm",
                        template: "<div class=\"img-preview-container\">\n              " + imagesContainer + "\n              </div><br />",
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "input",
                        key: "name",
                        defaultValue: this.data.name,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.name"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.name"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "select",
                        key: "shortDescription",
                        defaultValue: this.data.shortDescription,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.shortDescription"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.shortDescription"),
                            required: false,
                            options: [
                                {
                                    value: "externalPushButtonPanel",
                                    label: this.translateService.instant("propertyTagNfc.shortDescription.externalPushButtonPanel"),
                                },
                                {
                                    value: "understairsPushButtonPanel",
                                    label: this.translateService.instant("propertyTagNfc.shortDescription.understairsPushButtonPanel"),
                                },
                                {
                                    value: "dedicatedLocalAccessDoor",
                                    label: this.translateService.instant("propertyTagNfc.shortDescription.dedicatedLocalAccessDoor"),
                                },
                                {
                                    value: "driveway",
                                    label: this.translateService.instant("propertyTagNfc.shortDescription.driveway"),
                                },
                                {
                                    value: "other",
                                    label: this.translateService.instant("propertyTagNfc.shortDescription.other"),
                                },
                            ],
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "textarea",
                        key: "description",
                        defaultValue: this.data.description,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.description"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.description"),
                            required: false,
                            minLength: 0,
                            maxLength: 1000,
                            rows: 4
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "datepicker",
                        key: "installationDate",
                        defaultValue: this.data.installationDate,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.installationDate"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.installationDate"),
                            required: false,
                            disabled: true,
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "input",
                        key: "latitude",
                        defaultValue: this.data.latitude,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.latitude"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.latitude"),
                            required: false,
                            disabled: true,
                        },
                        wrappers: ['form-field-horizontal']
                    },
                    {
                        className: "col-12",
                        type: "input",
                        key: "longitude",
                        defaultValue: this.data.longitude,
                        templateOptions: {
                            label: this.translateService.instant("propertyTagNfc.fields.longitude"),
                            placeholder: this.translateService.instant("propertyTagNfc.fields.longitude"),
                            required: false,
                            disabled: true,
                        },
                        wrappers: ['form-field-horizontal']
                    },
                ],
            });
        }
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    PropertyTagNfcEditDialogComponent.prototype.onFormSubmit = function (model) {
        var e_2, _a;
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant('common.errors.form_is_invalid'));
            return;
        }
        if (model && model.files && Array.isArray(model.files)) {
            try {
                for (var _b = tslib_1.__values(model.files), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var image = _c.value;
                    image.path = image.path.replace("" + this.configService.apiHost, "");
                    image.path = image.path.replace(/^[\\]*uploads/, "uploads");
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        var sendData = {
            images: model.files,
            uid: model.uid,
            name: model.name,
            shortDescription: model.shortDescription,
            description: model.description,
            latitude: model.latitude,
            longitude: model.longitude,
            installationDate: model.installationDate,
            createdBy: model.createdBy,
            updatedBy: model.updatedBy,
            createdAt: model.createdAt,
            updatedAt: model.updatedAt
        };
        this.subscriptions.push(this.propertyTagNfcsService.updateFields(this.data._id, sendData)
            .pipe(finalize(function () { return _this.formBtnOptions.active = false; }))
            .subscribe(function (res) {
            if (res.status) {
                _this.toastrService.success(res.message);
                _this.onClose(res);
                return;
            }
            _this.toastrService.error(_this.translateService.instant('common.errors.unknown_server_error'));
        }, function (err) {
            // Choose one of the following error handling method.
            // 1) First one show a message right under the form fields
            //    (if the form is properly setted)
            // 2) Second one is used to show a mat-error under each field
            //    in the dynamic form (is meant to be used only in dynamicForm)
            // 3) Third one show toastr notifications for each error
            // 4) Fourth one is used to show mat-error under each field
            //    in the ngx-formly form (is mean to be used only with ngx-formly)
            // this.helperService.handleFormError(form, err);
            // this.helperService.handleDynamicFormError(form, err);
            // this.helperService.handleError(err);
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     *
     * @param [data] optional data passed to the caller component
     */
    PropertyTagNfcEditDialogComponent.prototype.onClose = function (data) {
        this.dialogRef.close(data);
    };
    /**
     * Toggle activation in all list elements
     *
     * @since 1.0.0
     */
    PropertyTagNfcEditDialogComponent.prototype.onToggleSelected = function (element) {
        var _this = this;
        if (!element.checked) {
            // Prevent invalid form submit
            if (this.form.invalid) {
                Object.keys(this.form.controls).forEach(function (key) {
                    _this.form.controls[key].markAsTouched();
                });
                this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
                element.source.toggle();
                return;
            }
        }
        this.enableEdit = element.checked;
        if (this.enableEdit) {
            this.options.formState = {
                disabled: false
            };
        }
        else {
            this.options.formState = {
                disabled: true
            };
        }
    };
    return PropertyTagNfcEditDialogComponent;
}());
export { PropertyTagNfcEditDialogComponent };
